<style scoped>
    .team{
        margin-top: 20px;
        border: 1px solid #dddee1;
        padding: 10px;
    }
    .team-title{
        font-size: 14px;
    }
    .team-name{
        display: inline-block;
        vertical-align: middle;
        font-size: 16px;
        font-weight: bold;
    }
    .team-info{
        display: inline-block;
        vertical-align: middle;
    }
    .director-topic-container{
        margin-top: 15px;
        margin-left: 20px;
    }
    .director-name{
        font-size: 12px;
        margin: 3px 0 8px 0;
    }
    .director-topic-item{
        display: inline-block;
        vertical-align: middle;
    }
    .record-container{
        /*margin-left: 5px;*/
    }
    .status-1{
        color: #1c2438;
    }
    .status-2{
        color: #ff9900;
    }
    .status-3{
        color: #2d8cf0;
    }
    .status-5{
        color: #19be6b;
    }
    .ivu-checkbox-wrapper {
        vertical-align: middle;
    }
</style>
<template>
  <div>
    <div
      v-if="topic.name"
      class="line text-center"
    >
      <h1>{{ topic.wage_month + ' ' + topic.name }} <small v-show="isTopicFinish">(已完成)</small></h1>
      <div>{{ topic.wage_start }}(含) - {{ topic.wage_end }}(含)</div>
    </div>
    <div class="list-container">
      <div
        v-for="team_info in teams"
        :key="team_info.team.id"
        class="team"
      >
        <div class="team-title">
          <span class="team-name">{{ team_info.team.name }}</span>
          <span v-if="!isTopicFinish">
            <Button
              size="small"
              @click="selectAllDirectorTopic(team_info, true)"
            >全选</Button>
            <Button
              size="small"
              @click="selectAllDirectorTopic(team_info, false)"
            >反选</Button>

            <Ajaxbtn
              v-show="showPassBtn(team_info)"
              :url="update_director_topics_status"
              :params="updateTeamStatusParams(team_info, 5)"
              :config="pass_status_config"
              @done="function(data){updateTeamDirectorTopic(data, team_info, 5)}"
              @fail="updateTeamDirectorTopicFail"
            />

            <Ajaxbtn
              :url="update_director_topics_status"
              :params="updateTeamStatusParams(team_info, 2)"
              :config="fail_status_config"
              @done="function(data){updateTeamDirectorTopic(data, team_info, 2)}"
              @fail="updateTeamDirectorTopicFail"
            />
          </span>
          <span class="team-info">
            <span>共 {{ team_info.customer_count }} 人</span>
            <span>, 工资总额 {{ team_info.total_wage }} 元</span>
            <span>, 含税总额 {{ team_info.pre_tax_wage }} 元</span>
          </span>
        </div>
        <div class="director-topic-container">
          <div
            v-for="director_topic in team_info.director_topics"
            :key="director_topic.id"
            class="director-topic"
          >
            <div class="director-name">
              <Checkbox
                v-show="!isTopicFinish"
                v-model="director_topic.check"
                :disabled="director_topic.disabled"
              >
                选择
              </Checkbox>
              <span class="director-topic-info">
                <Button
                  size="small"
                  @click="toggleDirectorTopicFold(director_topic)"
                >
                  <span v-show="director_topic.isFold">展开</span>
                  <span v-show="!director_topic.isFold">收起</span>
                </Button>
              </span>
              <span class="director-topic-item">{{ director_topic.director.account }} - </span>
              <span
                class="director-topic-item director-topic-status"
                :class="'status-' + director_topic.status"
              >
                {{ directorTopicStatus(director_topic.status) }}
              </span>
              <span class="director-topic-item">
                <span>共 {{ director_topic.customer_count }} 人</span>
                <span>, 工资总额 {{ director_topic.total_wage }} 元</span>
                <span>, 含税总额 {{ director_topic.pre_tax_wage }} 元</span>
              </span>
            </div>
            <div
              v-if="!director_topic.isFold"
              class="record-container"
            >
              <Table
                :loading="director_topic.loading"
                :row-class-name="rowClassName"
                :columns="record_columns"
                :data="director_topic.records"
                no-data-text="没有记录"
                size="small"
              />
              <div class="line">
                <span class="color-error">[红色]</span>表示该条工资记录已被废弃.
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        v-show="isTopicLoading"
        class="back-drop text-center"
      >
        <div class="loading-icon">
          <Spin size="large" />
        </div>
      </div>
    </div>
  </div>
</template>
<script :route="{path:'/team/team_outsource_wage_topic_detail/:id',noChkout: true}">
  import Util from '../../libs/util';
  export default {
    /* router_info_start */
    router_info: {
      path:'/team/team_outsource_wage_topic_detail/:id',
      noChkout: true
    },
    /* router_info_end */

    data() {
      return {
        record_columns: [
          {
            title: '合同号',
            key: 'uid',
            align: 'center',
            width: 100,
          },
          {
            title: '姓名',
            key: 'account',
            align: 'center',
            width: 80,
          },
          {
            title: '收款账户核验',
            align: 'center',
            render: (h, params) => {
              const row = params.row;
              return h('span', this.$util.threeCheckStatusName(row.three_check_status));
            }
          },
          {
            title: '支付信息',
            key: 'name',
            render: (h, params) => {
              const record = params.row;
              let bank_type = '';
              if (record.bank_type === 'bank') {
                bank_type = '银行卡';
              } else if (record.bank_type === 'alipay') {
                bank_type = '支付宝';
              } else {
                bank_type = '未定义支付方式';
              }
              return h('div', `${bank_type}: ${record.bank_number}`);
            }
          },
          {
            title: '工资总额(￥)',
            key: 'total_wage',
            align: 'center',
            width: 150,
            render: (h, params) => {
              const record = params.row;
              return h('span', Util.formatPrice(record.total_wage));
            }
          },
          {
            title: '含税总额(￥)',
            key: 'pre_tax_wage',
            align: 'center',
            width: 150,
            render: (h, params) => {
              const record = params.row;
              return h('span', Util.formatPrice(record.pre_tax_wage));
            }
          }
        ],
        // 获取列表时
        topic_empty_tip: '获取数据中...',
        isTopicLoading: false,
        topic: {},
        teams: [
          {
            team: {id: 0, name: '-'},
            director_topics: [
              {
                id: 0,
                status: 1,
                director: {account: '-'},
                records: []
              }
            ]
          }
        ],
        update_director_topics_status: Util.api.update_director_outsource_topics_status,
        pass_status_config: {
          size: 'small',
          type: 'primary',
          name: '通过',
          successedName: '通过成功',
          failedName: '通过失败',
        },
        fail_status_config: {
          size: 'small',
          type: 'warning',
          name: '驳回',
          successedName: '驳回成功',
          failedName: '驳回失败',
        }
      }
    },
    computed: {
      isTopicFinish() {
        return this.topic.status === 5;
      }
    },
    created() {
      this.getTeamTopicDetail();
    },
    methods: {
      rowClassName(row, index) {
        // 废弃
        if (row.status === 7) {
          return 'color-error';
        }
        // 有备注信息
        if (row.desc) {
          return 'color-warning';
        }
        return '';
      },
      getTeamTopicDetail() {
        if (!this.isTopicLoading) {
          this.isTopicLoading = true;
          this.empty_tip = '获取数据中...';
          Util.ajax.get(Util.api.team_outsource_wage_topic_detail_path, {
            params: {
              id: this.$route.params.id
            }
          }).then((response) => {
            return response.data;
          }).then((res) => {
            this.isTopicLoading = false;
            if (res.code === 1) {
              const data = res.data;
              this.topic = data.topic;
              this.teams = [];
              data.teams.forEach((team) => {
                team.customer_count = 0;
                team.total_wage = 0;
                team.pre_tax_wage = 0;
                team.director_topics.forEach((dt) => {
                  team.customer_count += dt.customer_count;
                  team.total_wage = math.eval(`${team.total_wage} + ${dt.total_wage}`).toFixed(2);
                  team.pre_tax_wage = math.eval(`${team.pre_tax_wage} + ${dt.pre_tax_wage}`).toFixed(2);
                  dt.check = false;
                  dt.loading = false;
                  dt.isFold = true;
                  dt.disabled = !([3, 5].indexOf(dt.status) > -1 && this.topic.status !== 5);
                });
                this.teams.push(team);
              });
            } else {
              this.$Modal.error({
                title: '错误',
                content: res.msg
              });
            }
          }).catch((e) => {
            this.isTopicLoading = false;
            this.empty_tip = '获取数据失败, 请刷新页面重试';
            console.log(e);
            this.$Modal.error({
              title: '错误',
              content: e.response.data
            });
          });
        }
      },
      directorTopicStatus(status) {
        let ret = '未定义状态';
        switch (status) {
        case 1:
          ret = '填写中';
          break;
        case 2:
          ret = '退回修改中';
          break;
        case 3:
          ret = '待审核';
          break;
        case 5:
          ret = '审核通过';
          break;
        }
        return ret;
      },
      getCustomerCountOfDirectorTopic(directorTopic) {
        return directorTopic.records ? directorTopic.records.length : 0;
      },
      getWageTotalOfDirectorTopic(directorTopic) {
        let total = 0;
        directorTopic.records.forEach((record) => {
          if (record.status !== 7) {
            total = math.eval(total + '+' + record.total_wage);
          }
        });
        return total.toFixed(2);
      },
      toggleDirectorTopicFold(directorTopic) {
        directorTopic.isFold = !directorTopic.isFold;
        if (!directorTopic.records.length && !directorTopic.isFold) {
          directorTopic.loading = true;
          Util.ajax.get(Util.api.director_outsource_wage_records, {
            params: {
              id: directorTopic.id
            }
          }).then((response) => {
            return response.data;
          }).then((data) => {
            directorTopic.loading = false;
            console.log(data);
            directorTopic.records = [];
            data.records.forEach((record) => {
              directorTopic.records.push(record);
            });
          }).catch((e) => {
            directorTopic.loading = false;
            console.log(e);
            this.$Modal.error({
              title: '错误',
              content: '获取数据失败, 请点击展开重试'
            });
          });
        }
      },
      updateTeamStatusParams(team, status) {
        const ids = [];
        team.director_topics.forEach((dt) => {
          if (dt.check) {
            ids.push(dt.id);
          }
        });
        return {
          topic_id: this.topic.id,
          ids: ids,
          status: status
        }
      },
      selectAllDirectorTopic(team, val) {
        team.director_topics.forEach((dt) => {
          if (!dt.disabled) {
            dt.check = val;
          }
        });
      },
      showPassBtn(team) {
        const len = team.director_topics.length;
        let show = false;
        for (let i = 0; i < len; i++) {
          if (team.director_topics[i].status === 3) {
            show = true;
            break;
          }
        }
        return show;
      },
      updateTeamDirectorTopic(data, team, status) {
        if (status === 5) {
          this.$Modal.success({
            title: '提示',
            content: '通过成功'
          });
        } else if (status === 2) {
          this.$Modal.success({
            title: '提示',
            content: '驳回成功'
          });
        }
        team.director_topics.forEach((dt) => {
          if (data.ids.indexOf(dt.id) > -1) {
            dt.status = status;
            dt.check = false;
            if (status <= 2) {
              dt.disabled = true;
            }
          }
        })
      },
      updateTeamDirectorTopicFail(e) {
        this.$Message.warning(e.message);
      }
    }
  }
</script>
